import { BaseQueryApi, FetchBaseQueryError, QueryReturnValue, retry } from "@reduxjs/toolkit/query/react";

import { router } from "@/main";
import { authSliceActions } from "@/store/slices/auth";

/**
 * Handles HTTP errors from API requests
 *
 * @param error - The error from the fetch request
 * @param api - RTK Query API instance
 * @param result - The result object containing error and meta
 * @returns Modified result with error handling applied
 */
export const handleApiError = (error: FetchBaseQueryError | undefined, api: BaseQueryApi, result: QueryReturnValue<unknown, FetchBaseQueryError, object>) => {
  if (!error) return result;

  const isAuthLoginEndpoint = api.endpoint === "loginDriver" || api.endpoint === "loginExped";

  // Handle 401 Unauthorized - clear auth and logout
  if (error.status === 401 && !isAuthLoginEndpoint) {
    api.dispatch(authSliceActions.logout());
    // Fail the retry to prevent infinite loops
    retry.fail(error, result.meta);
  }

  // Handle 403 Forbidden - role not authorized
  if (error.status === 403) {
    // Error message is already set in the baseQuery
    // Just return the error as-is
  }

  /**
   * Handles 503 Service Unavailable errors
   * Logs a message indicating the service is unavailable
   */
  if (error.status === "FETCH_ERROR") {
    console.log("Service unavailable");
    router.navigate({ to: "/503" });
  }

  return result;
};

/**
 * Creates a 403 Forbidden error response
 */
export const createForbiddenError = (): { error: FetchBaseQueryError } => {
  return {
    error: {
      status: 403,
      data: { message: "Acesso negado: role não autorizado para esta rota" }
    } as FetchBaseQueryError
  };
};
